import React from 'react';
import { GraduationCap, Users, MessageSquare, Flag } from 'lucide-react';

type ActionPanelsProps = {
  onDownloadPdf: () => void;
  onRestart: () => void;
};

export function ActionPanels({ onDownloadPdf, onRestart }: ActionPanelsProps) {
  return (
    <div className='bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 p-6 sm:p-8 rounded-2xl border border-blue-100 dark:border-blue-800 my-8'>
      <h3 className='text-xl sm:text-2xl font-bold text-text-light dark:text-white mb-6 flex items-center gap-2'>
        <Flag className='text-[#0369A1] w-6 h-6 sm:w-8 sm:h-8' />
        Các bước tiếp theo dành cho bạn
      </h3>

      <div className='grid grid-cols-1 md:grid-cols-3 gap-6'>
        {/* Step 1: Tìm hiểu trường & Khóa học */}
        <div className='bg-white dark:bg-card-dark p-6 rounded-xl border border-blue-100 dark:border-gray-700 shadow-md text-center'>
          <div className='w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-blue-100 dark:bg-blue-900/30 text-[#0369A1] flex items-center justify-center mb-4 mx-auto'>
            <GraduationCap className='w-6 h-6 sm:w-8 sm:h-8' />
          </div>
          <h4 className='font-bold text-base sm:text-lg mb-2'>Tìm hiểu trường &amp; Khóa học</h4>
          <p className='text-xs sm:text-sm text-subtext-light dark:text-subtext-dark leading-relaxed'>
            Dựa trên các ngành nghề gợi ý, hãy bắt đầu tìm kiếm các trường Đại học/Cao đẳng có thế mạnh đào tạo về Nghệ thuật và Xã hội.
          </p>
        </div>

        {/* Step 2: Tham gia hoạt động ngoại khóa */}
        <div className='bg-white dark:bg-card-dark p-6 rounded-xl border border-blue-100 dark:border-gray-700 shadow-md text-center'>
          <div className='w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-green-100 dark:bg-green-900/30 text-[#16a34a] flex items-center justify-center mb-4 mx-auto'>
            <Users className='w-6 h-6 sm:w-8 sm:h-8' />
          </div>
          <h4 className='font-bold text-base sm:text-lg mb-2'>Tham gia hoạt động ngoại khóa</h4>
          <p className='text-xs sm:text-sm text-subtext-light dark:text-subtext-dark leading-relaxed'>
            Tham gia các CLB nghệ thuật hoặc các dự án cộng đồng để trải nghiệm thực tế và rèn luyện kỹ năng mềm.
          </p>
        </div>

        {/* Step 3: Trao đổi với chuyên gia */}
        <div className='bg-white dark:bg-card-dark p-6 rounded-xl border border-blue-100 dark:border-gray-700 shadow-md text-center'>
          <div className='w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-orange-100 dark:bg-orange-900/30 text-[#F97316] flex items-center justify-center mb-4 mx-auto'>
            <MessageSquare className='w-6 h-6 sm:w-8 sm:h-8' />
          </div>
          <h4 className='font-bold text-base sm:text-lg mb-2'>Trao đổi với chuyên gia</h4>
          <p className='text-xs sm:text-sm text-subtext-light dark:text-subtext-dark leading-relaxed'>
            Đặt lịch tư vấn với các chuyên gia hướng nghiệp của Viện để có lộ trình học tập cụ thể hơn.
          </p>
        </div>
      </div>
    </div>
  );
}

